export function getNonBillableTime(timeRegistered = 0, billableTimeRegistered = 0): number {
	const nonBillableTime = timeRegistered - billableTimeRegistered;
	return nonBillableTime;
}
